import React from 'react';

import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import useStyles from './ImportCertificate.styled';
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';
import i18n from 'i18n-js';
import * as Yup from 'yup';
import PropTypes from 'prop-types';
import { Formik, Field } from 'formik';
import { TextareaField } from 'components/FormFields';
import InfoIcon from '@material-ui/icons/Info';
import { Tooltip } from '@material-ui/core';
import { useDispatch } from 'react-redux';
import { AuthActions } from 'state/modules/auth';

const InfoTooltip = ({ title, className }) => {
  return (
    <Tooltip title={title} className={className}>
      <InfoIcon color="primary" />
    </Tooltip>
  );
};

const ImportCertificate = ({ formRef, errors }) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const formSchema = Yup.object().shape({
    certificate: Yup.string().required(i18n.t('common.required_field')),
  });

  const initialValues = {
    certificate: '',
  };

  const onSubmit = (values) => {
    dispatch(AuthActions.fetchImportCertificate(values, 'details'));
  };

  return (
    <Box className={classes.container}>
      <Container className="h-100">
        <Grid
          container
          className={classes.container}
          direction="row"
          justifyContent="center"
          alignItems="center"
        >
          <Grid item xs={12}>
            <Typography color="textPrimary" component="div" align="left">
              <Box fontSize={16} component="h5" lineHeight={1}>
                {i18n.t('authentication.steps.certificate')}
              </Box>
            </Typography>
            <Typography
              color="textPrimary"
              component="div"
              align="justify"
              className={classes.description}
            >
              <Box fontSize={14} mt={2} mb={4} lineHeight={1} component="div">
                <span
                  dangerouslySetInnerHTML={{
                    __html: i18n.t('authentication.wizard.import_certiticate_description'),
                  }}
                />
              </Box>
            </Typography>
          </Grid>
          <Grid item xs={12} sm={10}>
            <Formik
              innerRef={formRef}
              initialValues={initialValues}
              validationSchema={formSchema}
              enableReinitialize={true}
              onSubmit={onSubmit}
            >
              {({ handleSubmit }) => (
                <form noValidate onSubmit={handleSubmit}>
                  <Grid container spacing={4} direction="row" justifyContent="flex-start">
                    <Grid item xs={3}>
                      <b>{i18n.t('authentication.wizard.certificate')}</b>
                      <InfoTooltip
                        title={i18n.t('authentication.wizard.tooltip.certificate')}
                        disabled={false}
                        className={classes.tooltipSize}
                      />
                    </Grid>
                    <Grid item xs={9}>
                      <Field
                        rows={2}
                        type="text"
                        name="certificate"
                        required={true}
                        variant="outlined"
                        component={TextareaField}
                        className={classes.textAreaStyles}
                        asyncErrors={errors?.certificate}
                      />
                    </Grid>
                  </Grid>
                </form>
              )}
            </Formik>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

ImportCertificate.propTypes = {
  formRef: PropTypes.object,
  errors: PropTypes.object,
  step: PropTypes.shape({
    certificate: PropTypes.string,
  }),
  onSave: PropTypes.func,
};

InfoTooltip.propTypes = {
  title: PropTypes.string.isRequired,
  className: PropTypes.string,
};

export default ImportCertificate;
